import { assign } from 'xstate5';

import { type ModalMachineAction } from '../modal-machine.types';

// ─────────────────────────────────────────────────────────────────────────────

const setActive: ModalMachineAction = assign(() => ({ active: true }));

const setInactive: ModalMachineAction = assign(() => ({ active: false }));

// ─────────────────────────────────────────────────────────────────────────────

export const Actions = {
  setActive,
  setInactive,
};
